import { PhoneNumbersService } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-numbers/phone_numbers_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaPhoneNumbersV1Service = bindHTTP(PhoneNumbersService);
export const serviceName = 'phone-numbers-v1' as const;
